var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "mb-1" }, [
      _c(
        "div",
        {
          staticClass: "btn-group btn-group-toggle",
          attrs: { "data-toggle": "buttons" },
        },
        [
          _c(
            "label",
            {
              class: {
                "btn btn-outline-primary": true,
                active: +_vm.action === 1,
              },
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.action,
                    expression: "action",
                  },
                ],
                attrs: { type: "radio", name: "options", value: "1" },
                domProps: { checked: _vm._q(_vm.action, "1") },
                on: {
                  change: function ($event) {
                    _vm.action = "1"
                  },
                },
              }),
              _vm._v(" Перезвон\n      "),
            ]
          ),
          _vm._v(" "),
          _c(
            "label",
            {
              class: {
                "btn btn-outline-primary": true,
                active: +_vm.action === 2,
              },
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.action,
                    expression: "action",
                  },
                ],
                attrs: { type: "radio", value: "2" },
                domProps: { checked: _vm._q(_vm.action, "2") },
                on: {
                  change: function ($event) {
                    _vm.action = "2"
                  },
                },
              }),
              _vm._v(" Уведомление\n      "),
            ]
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-8" }, [
        _c("div", { staticClass: "form-group mb-0" }, [
          _vm._v("\n        Сообщение для уведомления\n        "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.message,
                expression: "message",
              },
            ],
            staticClass: "form-control",
            attrs: { type: "text", placeholder: "Текст уведомления" },
            domProps: { value: _vm.message },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.message = $event.target.value
              },
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-4 flex" }, [
        _c(
          "div",
          { staticClass: "form-group mb-0" },
          [
            _vm._v("\n        Время активации уведомления\n        "),
            _c("DateTimeSelect", {
              ref: "selectedDateTime",
              attrs: {
                customShortCutsDates: "orderNotifications",
                disabled: true,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "ml-2" },
          [
            _c("LoadingButton", {
              attrs: {
                title: "Создать уведомление",
                className: "btn btn-outline-success save_btn",
                loading: _vm.loading,
                color: _vm.$constants.LOADING_COLOR,
                onClick: () => _vm.saveNotification(),
              },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }